'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var signupFlow = require('./signup-flow');
var signupConstants = require('./signup-constants');
require('./signup-form');

/* _ global ShopifyMarketing _ */

function noop() {
  return undefined;
}
/**
 * The Signup Modal were responsible to open a signup form into a modal on the page
 * @deprecated Signup now lives on the new funnel
 */


function SignupModal(elements) {
  const $inlineForm = document.querySelectorAll(signupConstants.SELECTORS.INLINE_FORM_SELECTOR);
  const $modalSources = (elements === null || elements === void 0 ? void 0 : elements.length) > 0 ? [...elements] : [];

  function onElementClick(event) {
    event.preventDefault();
    signupFlow.initSignupFlow($inlineForm);
  }

  function onFormSubmit(event) {
    event.preventDefault();
    signupFlow.initSignupFlow($inlineForm);
  }

  $inlineForm.forEach(form => form && form.addEventListener('submit', onFormSubmit));
  $modalSources.forEach(modal => modal && modal.addEventListener('click', onElementClick)); // For compatibility with the previous version used by third parties.

  this.$signupForm = document.querySelector(signupConstants.SELECTORS.HIDDEN_FORM_SELECTOR);
  this.render = noop;
  this.close = noop;
  this.captureEmail = noop;

  this.open = function open() {
    signupFlow.initSignupFlow($inlineForm);
  };
}

exports.default = SignupModal;
